import React from 'react';
export function SiteFooter() {
  return <footer className="border-t border-white/10 bg-[#123b35] px-5 py-8 text-sm text-[#a7c7bd] sm:px-8" data-id="element-135">
      <div className="mx-auto flex max-w-7xl flex-col justify-between gap-4 sm:flex-row" data-id="element-136">
        <p data-id="element-137">
          © {new Date().getFullYear()} Natural Swimming Pools. Phoenix,
          Arizona.
        </p>
        <div className="flex gap-5" data-id="element-138">
          <a href="#top" className="hover:text-white" data-id="element-139">
            Back to top
          </a>
          <a href="tel:+16025656313" className="hover:text-white" data-id="element-140">
            (602) 565-6313
          </a>
        </div>
      </div>
    </footer>;
}